var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showButton,
              expression: "showButton"
            }
          ],
          staticClass: "section operations  align-right"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cooperateEdit,
                  expression: "cooperateEdit"
                }
              ],
              staticClass: "triggers"
            },
            [
              _c("cargo-button-group-slider", [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "New", type: "primary" },
                        on: { click: _vm.onAdd }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.New")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "Edit",
                          type: "primary",
                          disabled: !_vm.btnEnable.btnEdit
                        },
                        on: { click: _vm.onEdit }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "Delete",
                          type: "danger",
                          disabled: !_vm.btnEnable.btnRemove
                        },
                        on: { click: _vm.onRemove }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "Clone",
                          type: "primary",
                          disabled: !_vm.btnEnable.btnClone
                        },
                        on: { click: _vm.onClone }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "Send2",
                          type: "primary",
                          disabled: !_vm.btnEnable.btnSend
                        },
                        on: { click: _vm.onSend }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Send2")))]
                    ),
                    _vm.btnVisible.btnBack
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              no: "Back",
                              type: "primary",
                              disabled: !_vm.btnEnable.btnBack
                            },
                            on: { click: _vm.onBack }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Back")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "SendBack",
                          type: "primary",
                          disabled: !_vm.btnEnable.btnReturn
                        },
                        on: { click: _vm.onReturn }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.SendBack")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "ExpressInfo",
                          type: "primary",
                          disabled: !_vm.btnEnable.btnInfo
                        },
                        on: { click: _vm.onExInfo }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ExpressInfo")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "PrintReceipt", type: "success" },
                        on: { click: _vm.onReceipt }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.PrintReceipt")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "PrintChargebackList", type: "success" },
                        on: { click: _vm.onPrint }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.PrintChargebackList")))]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", "min-height": "350px" },
            attrs: {
              "config-module": "130128",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section file-from-bg" },
        [
          _c(
            "el-form",
            { staticClass: "file-form", attrs: { "label-width": "140px" } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.FileType") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      filterable: "",
                      "select-type":
                        _vm.selectTypeNames.basic_data_TransmitFileType,
                      "default-value": _vm.selectedFile.fileType,
                      disabled: true
                    }
                  })
                ],
                1
              ),
              _vm.fileView.txtCheckStatusOfCustomsDeclaration
                ? _c(
                    "el-form-item",
                    { staticClass: "label-none custom" },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "text-decoration": "underline",
                            border: "0"
                          },
                          on: { click: _vm.stateQueryClickHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              this.$t(
                                "SeaExport.CheckStatusOfCustomsDeclaration"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.TenBitCode") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "tenDigitCode",
                      readonly: true,
                      maxlength: "10",
                      disabled: true
                    },
                    model: {
                      value: _vm.selectedFile.tenDigitCode,
                      callback: function($$v) {
                        _vm.$set(_vm.selectedFile, "tenDigitCode", $$v)
                      },
                      expression: "selectedFile.tenDigitCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.ReceiverCompanyName") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "receiveCompany",
                      readonly: true,
                      disabled: true
                    },
                    model: {
                      value: _vm.selectedFile.receiveCompany,
                      callback: function($$v) {
                        _vm.$set(_vm.selectedFile, "receiveCompany", $$v)
                      },
                      expression: "selectedFile.receiveCompany"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.Tel") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { no: "receiveTel", readonly: true, disabled: true },
                    model: {
                      value: _vm.selectedFile.receiveTel,
                      callback: function($$v) {
                        _vm.$set(_vm.selectedFile, "receiveTel", $$v)
                      },
                      expression: "selectedFile.receiveTel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.CustomsDeclarationPages") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      no: "customsPageNumber",
                      readonly: true,
                      disabled: true
                    },
                    model: {
                      value: _vm.selectedFile.customsPageNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.selectedFile, "customsPageNumber", $$v)
                      },
                      expression: "selectedFile.customsPageNumber"
                    }
                  }),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { width: "100px", "padding-left": "10px" },
                      attrs: { no: "customsTransfer", disabled: true },
                      model: {
                        value: _vm.selectedFile.customsTransfer,
                        callback: function($$v) {
                          _vm.$set(_vm.selectedFile, "customsTransfer", $$v)
                        },
                        expression: "selectedFile.customsTransfer"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsTransitOrNot")))]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.CustomsBroker") }
                },
                [
                  _c("cargo-company-select", {
                    staticStyle: { width: "300px", display: "inline-block" },
                    attrs: {
                      disabled: true,
                      "method-params": {
                        customsBroker: true,
                        seaExport: true,
                        active: true
                      },
                      "default-value": _vm.selectedFile.customsBroker || ""
                    },
                    on: {
                      change: function(p) {
                        _vm.selectedFile.customsBroker = p.value
                      }
                    }
                  }),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { width: "100px", "padding-left": "10px" },
                      attrs: { no: "tax", disabled: true },
                      model: {
                        value: _vm.selectedFile.tax,
                        callback: function($$v) {
                          _vm.$set(_vm.selectedFile, "tax", $$v)
                        },
                        expression: "selectedFile.tax"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.TakeByCustomsBroker")))]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.ExpressAddress") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "expressAddress",
                      type: "textarea",
                      rows: 3,
                      readonly: true,
                      disabled: true
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.ExpressAddress"),
                          _vm.selectedFile.expressAddress,
                          function(val) {
                            _vm.selectedFile.expressAddress = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.selectedFile.expressAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.selectedFile, "expressAddress", $$v)
                      },
                      expression: "selectedFile.expressAddress"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            { staticClass: "file-form", attrs: { "label-width": "140px" } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.FileNo") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { no: "fileNo", readonly: true, disabled: true },
                    model: {
                      value: _vm.selectedFile.fileNo,
                      callback: function($$v) {
                        _vm.$set(_vm.selectedFile, "fileNo", $$v)
                      },
                      expression: "selectedFile.fileNo"
                    }
                  })
                ],
                1
              ),
              _vm.fileView.checkPreRecordedCustomsDeclaration
                ? _c(
                    "el-form-item",
                    { staticClass: "label-none custom" },
                    [
                      _c(
                        "el-dropdown",
                        {
                          attrs: {
                            "split-button": "",
                            type: "primary",
                            trigger: "click"
                          },
                          on: { command: _vm.onLogPopUpMenu }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.fileView.command) + " "),
                          _vm._l(_vm.fileView.buttonArry, function(item) {
                            return _c(
                              "el-dropdown-menu",
                              {
                                key: item.id,
                                attrs: { slot: "dropdown" },
                                slot: "dropdown"
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: item.value } },
                                  [_vm._v(_vm._s(item.value))]
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.OperatingCompany") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "companyCname",
                      readonly: true,
                      disabled: true
                    },
                    model: {
                      value: _vm.selectedFile.companyCname,
                      callback: function($$v) {
                        _vm.$set(_vm.selectedFile, "companyCname", $$v)
                      },
                      expression: "selectedFile.companyCname"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.Receiver2") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "receivePerson",
                      readonly: true,
                      disabled: true
                    },
                    model: {
                      value: _vm.selectedFile.receivePerson,
                      callback: function($$v) {
                        _vm.$set(_vm.selectedFile, "receivePerson", $$v)
                      },
                      expression: "selectedFile.receivePerson"
                    }
                  })
                ],
                1
              ),
              this.job && this.job.lob === "SE"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Addr") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "receiveAddress",
                          readonly: true,
                          disabled: true
                        },
                        model: {
                          value: _vm.selectedFile.receiveAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.selectedFile, "receiveAddress", $$v)
                          },
                          expression: "selectedFile.receiveAddress"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.TradeMethod") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "tradeModeName",
                      readonly: true,
                      disabled: true
                    },
                    model: {
                      value: _vm.selectedFile.tradeModeName,
                      callback: function($$v) {
                        _vm.$set(_vm.selectedFile, "tradeModeName", $$v)
                      },
                      expression: "selectedFile.tradeModeName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedFile.fileType === "3",
                      expression: "selectedFile.fileType==='3'"
                    }
                  ],
                  attrs: { label: _vm.$t("SeaExport.DateOfDeclaration") }
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "declareDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      disabled: true
                    },
                    model: {
                      value: _vm.selectedFile.declareDate,
                      callback: function($$v) {
                        _vm.$set(_vm.selectedFile, "declareDate", $$v)
                      },
                      expression: "selectedFile.declareDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.Remarks") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "remark",
                      type: "textarea",
                      rows: 3,
                      readonly: true,
                      disabled: true
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.Remarks"),
                          _vm.selectedFile.remark,
                          function(val) {
                            _vm.selectedFile.remark = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.selectedFile.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.selectedFile, "remark", $$v)
                      },
                      expression: "selectedFile.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "DocumentDelivery",
            visible: _vm.sendOutDialog.visible,
            title: _vm.$t("SeaExport.DocumentDelivery"),
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.sendOutDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "65px", "label-position": "left" } },
            [
              _c(
                "el-radio-group",
                {
                  staticClass: "custom",
                  on: {
                    change: function($event) {
                      return _vm.sendOutCustomTypeChange()
                    }
                  },
                  model: {
                    value: _vm.sendOutDialog.customerType,
                    callback: function($$v) {
                      _vm.$set(_vm.sendOutDialog, "customerType", $$v)
                    },
                    expression: "sendOutDialog.customerType"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.bookingParty")))
                  ]),
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.Customer")))
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.CustomsBrokerOthers")))
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ReceiverCompanyName") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.sendOutDialog.formData.receiveCompany,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.sendOutDialog.formData,
                          "receiveCompany",
                          $$v
                        )
                      },
                      expression: "sendOutDialog.formData.receiveCompany"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Receiver2") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.sendOutDialog.formData.receivePerson,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.sendOutDialog.formData,
                          "receivePerson",
                          $$v
                        )
                      },
                      expression: "sendOutDialog.formData.receivePerson"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ReceivingAddress") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.sendOutDialog.formData.receiveAddress,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.sendOutDialog.formData,
                          "receiveAddress",
                          $$v
                        )
                      },
                      expression: "sendOutDialog.formData.receiveAddress"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactNumber") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.sendOutDialog.formData.receiveTel,
                      callback: function($$v) {
                        _vm.$set(_vm.sendOutDialog.formData, "receiveTel", $$v)
                      },
                      expression: "sendOutDialog.formData.receiveTel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_CourierOrderNo") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.sendOutDialog.formData.expressNo,
                      callback: function($$v) {
                        _vm.$set(_vm.sendOutDialog.formData, "expressNo", $$v)
                      },
                      expression: "sendOutDialog.formData.expressNo"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sendOutPrint } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sendOutSend } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Send2")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.sendOutDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "takeBackDialog",
            visible: _vm.takeBackDialog.visible,
            title: _vm.takeBackDialog.dataLabelTitle,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.takeBackDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px", "label-position": "left" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.takeBackDialog.dataLabel } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      clearable: false,
                      "value-format": "yyyy-MM-dd",
                      "picker-options": _vm.pickerOptions
                    },
                    model: {
                      value: _vm.takeBackDialog.backDate,
                      callback: function($$v) {
                        _vm.$set(_vm.takeBackDialog, "backDate", $$v)
                      },
                      expression: "takeBackDialog.backDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.takeBackSave } },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.takeBackDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "BatchPrint",
            visible: _vm.returnDialog.visible,
            title: _vm.$t("SeaExport.BatchPrint"),
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.returnDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "80px", "label-position": "left" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Customer") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.returnDialog.formData.companyCName,
                      callback: function($$v) {
                        _vm.$set(_vm.returnDialog.formData, "companyCName", $$v)
                      },
                      expression: "returnDialog.formData.companyCName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Receiver2") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.returnDialog.formData.receiver,
                      callback: function($$v) {
                        _vm.$set(_vm.returnDialog.formData, "receiver", $$v)
                      },
                      expression: "returnDialog.formData.receiver"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactNumber") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.returnDialog.formData.tel,
                      callback: function($$v) {
                        _vm.$set(_vm.returnDialog.formData, "tel", $$v)
                      },
                      expression: "returnDialog.formData.tel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ExpressAddress") } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 3 },
                    model: {
                      value: _vm.returnDialog.formData.address,
                      callback: function($$v) {
                        _vm.$set(_vm.returnDialog.formData, "address", $$v)
                      },
                      expression: "returnDialog.formData.address"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ReturnExpressNumber") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.returnDialog.formData.expressNo,
                      callback: function($$v) {
                        _vm.$set(_vm.returnDialog.formData, "expressNo", $$v)
                      },
                      expression: "returnDialog.formData.expressNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ReturnDate") } },
                [
                  _c("el-date-picker", {
                    attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                    model: {
                      value: _vm.returnDialog.formData.returnDate,
                      callback: function($$v) {
                        _vm.$set(_vm.returnDialog.formData, "returnDate", $$v)
                      },
                      expression: "returnDialog.formData.returnDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.returnPrintHandler(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.returnPrintHandler(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Chargeback")))]
              ),
              _c("el-button", { on: { click: _vm.returnCancle } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "fastMailDialog",
            visible: _vm.fastMailDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_ExpressInfo"),
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.fastMailDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "85px", "label-position": "left" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ReceiverCompanyName") } },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: this.fastMailDialog.exprssInfo.sendReceiveCompany,
                      callback: function($$v) {
                        _vm.$set(
                          this.fastMailDialog.exprssInfo,
                          "sendReceiveCompany",
                          $$v
                        )
                      },
                      expression:
                        "this.fastMailDialog.exprssInfo.sendReceiveCompany"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Receiver2") } },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: this.fastMailDialog.exprssInfo.sendReceivePerson,
                      callback: function($$v) {
                        _vm.$set(
                          this.fastMailDialog.exprssInfo,
                          "sendReceivePerson",
                          $$v
                        )
                      },
                      expression:
                        "this.fastMailDialog.exprssInfo.sendReceivePerson"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ReceivingAddress") } },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: this.fastMailDialog.exprssInfo.sendExpressAddress,
                      callback: function($$v) {
                        _vm.$set(
                          this.fastMailDialog.exprssInfo,
                          "sendExpressAddress",
                          $$v
                        )
                      },
                      expression:
                        "this.fastMailDialog.exprssInfo.sendExpressAddress"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactNumber") } },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: this.fastMailDialog.exprssInfo.sendReceiveTel,
                      callback: function($$v) {
                        _vm.$set(
                          this.fastMailDialog.exprssInfo,
                          "sendReceiveTel",
                          $$v
                        )
                      },
                      expression:
                        "this.fastMailDialog.exprssInfo.sendReceiveTel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_CourierOrderNo") } },
                [
                  _c("el-input", {
                    attrs: { readonly: true },
                    model: {
                      value: this.fastMailDialog.exprssInfo.sendExpressNo,
                      callback: function($$v) {
                        _vm.$set(
                          this.fastMailDialog.exprssInfo,
                          "sendExpressNo",
                          $$v
                        )
                      },
                      expression: "this.fastMailDialog.exprssInfo.sendExpressNo"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.fastMailDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("el-input", {
            attrs: { type: "textarea", rows: "10" },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("file-dialog", {
        ref: "fileDialog",
        attrs: {
          visible: _vm.editDialog.visible,
          "selected-file": _vm.selectedFile,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          successHandler: _vm.successHandler
        }
      }),
      _c("customs-info-file-dialog", {
        ref: "customsInfoFile",
        attrs: {
          visible: _vm.customsInfoFiledialog.visible,
          model: _vm.customsInfoFiledialog.model,
          category: _vm.customsInfoFiledialog.category
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.customsInfoFiledialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "StatusOfCustomsDeclaration",
            visible: _vm.fileView.isCustomsStatusTitle,
            title: _vm.$t("SeaExport.StatusOfCustomsDeclaration"),
            width: "600px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.fileView, "isCustomsStatusTitle", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "300px" },
            attrs: {
              "config-module": "130129",
              "grid-options": _vm.gridOptionsCustomsStatus,
              "column-defs": _vm.columnDefsCustomsStatus,
              "row-data": _vm.rowDataCustomsStatus
            },
            on: {
              gridReady: function(params) {
                _vm.gridApiFileDetail = params.api
              }
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.fileView.isCustomsStatusTitle = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }